export default __webpack_public_path__ + "static/media/desk.a8c62685.jpg";